import { makeQuery } from 'shared/utilities';

type RequestType = {
    id: number | null
}

type ResponseType = {};

export const boardsDeleteQuery = async function (request: RequestType) {
    return await makeQuery<ResponseType>('/boards/delete', {
        prefix: 'task-tracker',
        json: request
    });
}
